import { formatCheckedTime } from "@/lib/format";
import { serviceHealthDisplay } from "@/lib/trust";
import { StatusDot } from "@/components/ui/Badge";
import type { PlatformService } from "@/types";

interface ServiceHealthCardProps {
  service: PlatformService;
  onSelect: (service: PlatformService) => void;
}

export function ServiceHealthCard({ service, onSelect }: ServiceHealthCardProps) {
  const health = serviceHealthDisplay(service.status, service.hasLiveData);

  return (
    <button
      type="button"
      className="service-card service-card--clickable"
      onClick={() => onSelect(service)}
    >
      <div className="service-card__head">
        <span className="service-card__name">{service.name}</span>
        <span className="service-card__status">
          <StatusDot status={health.tone} label={`${service.name} ${health.label}`} />
          <span className={`service-card__status-label service-card__status-label--${health.tone}`}>
            {health.label}
          </span>
        </span>
      </div>
      <p className="service-card__desc">
        {service.hasLiveData ? service.description : "Not available — no live probe data"}
      </p>
      {service.hasLiveData ? (
        service.affectedTenants > 0 ? (
          <p className="service-card__affected">
            {service.affectedTenants} affected tenant{service.affectedTenants === 1 ? "" : "s"}
          </p>
        ) : (
          <p className="service-card__affected service-card__affected--none">No affected tenants</p>
        )
      ) : (
        <p className="service-card__affected service-card__affected--none">Live status unknown</p>
      )}
      <div className="service-card__foot">
        <span>
          {service.hasLiveData ? formatCheckedTime(service.lastChecked) : "Last checked: Unknown"}
        </span>
        <span className="service-card__action">Details →</span>
      </div>
    </button>
  );
}

interface ServiceHealthGridProps {
  services: PlatformService[];
  onSelectService: (service: PlatformService) => void;
}

export function ServiceHealthGrid({ services, onSelectService }: ServiceHealthGridProps) {
  return (
    <div className="service-grid">
      {services.map((service) => (
        <ServiceHealthCard key={service.id} service={service} onSelect={onSelectService} />
      ))}
    </div>
  );
}
